<template>
  <CRow>
    <CCol lg="12" md="12" sm="12">
      <CCard>
        <CCardHeader>
          <strong>Quản lý sản phẩm đã sản xuất</strong>
          <div class="card-header-actions">
            <CButton v-if="isSuper && detail" type="button"
                     shape="pill" color="danger" class="mr-1"
                     :disabled="!validToUpdate"
                     @click="renameProjectForProduct"
            ><CIcon name="cil-save" class="mr-1"/>CN Lô SX</CButton>

            <CButton v-if="detail" type="button"
                     shape="pill" color="info" class="mr-1"
                     @click="requestProductDate">
              <CIcon name="cil-filter" class="mr-1"/>Lọc theo ngày</CButton>

            <CButton type="button" shape="pill" color="info" class="mr-1" @click="showTool">
              <CIcon name="cil-hand-point-up"/>
              Công cụ</CButton>
            <CButton type="button" shape="pill" color="info" class="mr-1" @click="createProduct">
              <CIcon name="cil-plus"/>
              Thêm mới</CButton>
            <CButton v-if="isSuper" type="button" shape="pill" color="info" class="mr-1" @click="importData">
              <CIcon name="cil-plus"/>
              Nhập từ tệp</CButton>
            <CButton v-if="detail" type="button" shape="pill" color="secondary" class="mr-1" @click="goBack">
              <CIcon name="cil-chevron-left"/>
              Quay lại</CButton>
          </div>
        </CCardHeader>
        <CCardBody class="pt-1">
          <p v-if="currentItems && currentItems.length > 0" class="pb-0 mb-0">Số lượng: <strong>{{ formatNumber(currentItems.length) }}</strong></p>
          <CRow v-if="isSuper && detail">
            <CCol>
              <CInput type="date" label="Sản xuất từ ngày:"
                      v-model="startDate"
                      :addLabelClasses="'text-right'"
                      :max="todayStr"
              />
            </CCol>
            <CCol>
              <CInput type="date" label="Đến ngày:"
                      v-model="stopDate"
                      :max="todayStr"
                      :addLabelClasses="'text-right'"/>
            </CCol>
            <CCol>
              <CSelect
                label="Lô sản xuất:"
                placeholder="Cập nhật vào lô sản xuất:"
                :options="projectsUseProduct"
                :value.sync="targetProject"
                :addLabelClasses="'text-right'"
              />
            </CCol>
          </CRow>

          <CDataTable
            :items="currentItems"
            :fields="getCurrentFields"
            :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
            :itemsPerPageSelect="{label:' ', values: ['10', '100', '200']}"
            :itemsPerPage="100"
            column-filter
            hover
            sorter
            pagination
            clickable-rows
            @row-clicked="rowClicked"
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>
            <template #lic_key="{item}">
              <td>
                <CIcon v-if="item.lic_key" name="cil-lock-unlocked"/>
              </td>
            </template>

            <template #product="{ item }">
              <td>
                <a class="clickable-text"  @click.stop="onActionClick(item)">{{item.product}}</a>
              </td>
            </template>

            <template #stt="{item, index}">
              <td class="py-2">
                {{index+1}}
              </td>
            </template>
            <template #produced="{item}">
              <td class="py-2 text-right">
                {{formatNumber(item.produced)}}
              </td>
            </template>

          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>

    <CModal
      :show.sync="darkModal"
      :no-close-on-backdrop="true"
      title="Modal title 2"
      color="info"
      :centered="true"
    >
      <CSelect label="Chọn công cụ:"
              :options="['Tạo ECODE', 'Tạo MAC']"
              :value.sync="utilities.mode"
              :addLabelClasses="'text-right'"
              :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}"/>
      <CInput label="Bắt đầu:" type="text"
              v-model="utilities.start"
              :addLabelClasses="'text-right'"
              :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}"/>
      <CInput label="Số lượng:"
              v-model.number="utilities.count"
              type="number" min="0"
              :addLabelClasses="'text-right'"
              :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}"/>
      <template #header>
        <strong class="modal-title">Công cụ</strong>
        <CButtonClose @click="darkModal = false" class="text-white"/>
      </template>
      <template #footer>
        <CButton color="info"
                 @click="requestTool">
          <CIcon name="cil-hand-point-up" class="mr-2"/>Tạo</CButton>
        <CButton @click="darkModal = false" color="secondary"><CIcon name="cil-x" class="mr-2"/>Đóng</CButton>
      </template>
    </CModal>

  </CRow>
</template>

<script>

export default {
  data() {
    const today = new Date();
    const past = new Date();
    past.setMonth(past.getMonth() - 6);
    const startStr=past.toISOString().split("T")[0]
    const stopStr=today.toISOString().split("T")[0]
    return {
      detail: false,
      isSuper: false,
      currentItems: [],
      // Define the table fields
      allTypeFields: [
        { key: 'stt', label: 'Stt', _style:'width:3rem;' },
        { key: 'product', label: 'Tên sản phẩm', _classes: 'font-weight-bold' },
        { key: 'description', label: 'Mô tả' },
        { key: 'produced', label: 'Đã sản xuất', _style: 'text-align: center;' },
        // { key: 'delivered', label: 'Đã giao hàng' },
        { key: 'note', label: 'Ghi chú' },
      ],
      productFileds: [
        { key: 'stt', label: 'Stt', _style:'width:3rem;' },
        { key: 'product', label: 'Tên sản phẩm', _classes: 'font-weight-bold' },
        { key: 'uuid', label: 'Seri' },
        { key: 'app_crc', label: 'CRC' },
        //{ key: 'mac', label: 'MAC' },
        //{ key: 'code', label: 'Code' },
        { key: 'project', label: 'Lô sản xuất' },
        //{ key: 'lic_key', label: 'license' },
        { key: 'date', label: 'Ngày SX' },
        { key: 'who', label: 'Thực hiện' },
        { key: 'factory', label: 'Nhà máy' },
        { key: 'note', label: 'Ghi chú' },
        { key: 'detail', label: 'Chi tiết' },
      ],
      withProject: '',
      darkModal: false,
      utilities: {
        mode: 'Tạo ECODE',
        start: '',
        count: 0,
      },
      projectsUseProduct: [],
      currentProduct: '',
      targetProject: '',
      startDate: startStr,
      stopDate: stopStr,
      todayStr: new Date().toISOString().split("T")[0],
    };
  },
  computed: {
    getCurrentFields() {
      return this.detail ? this.productFileds : this.allTypeFields
    },
    validToUpdate: function () {
      if (!this.targetProject || !this.currentProduct) {
        return false;
      }
      const today = new Date().toISOString().split("T")[0];
      const date0 = Date.parse(today);
      const date1 = Date.parse(this.startDate);
      const date2 = Date.parse(this.stopDate);
      return date1 <= date2 && date2 <= date0;
    }
  },
  created() {
    this.withProject = this.$route.query.project
    this.getSuper()
    this.getProductTypes(this.withProject)
  },
  methods: {
    getSuper() {
      const role = localStorage.getItem('role')
      this.isSuper = ((role === 'root') || (role === 'super'))
    },
    importData() {
      this.$router.push({
        path: "/device/import"
      })
    },
    createProduct() {
      this.editProduct()
    },
    showTool() {
      // console.log('showTool')
      this.darkModal=true;
    },
    requestTool(){
      // console.log('action: ', this.actionMode, 'start: ',
      //   this.actionStart, 'number: ', this.actionNumber);
      this.$request.post(`/api/device/utilities`, this.utilities).then(res => {
        // console.log(res.data)
        if(res.data.status === 'success') {
          this.downloadFile(res.data.filename)
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Thao tác",
            html: "Thao tác: " + this.utilities.mode + " lỗi: " + res.data.status,
          });
        }
      })
    },
    downloadFile(fileName) {
      // console.log('downloadFile', fileName)
      this.$request.get(`/api/repo/downloadbill/${fileName}`, { responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
          // document.body.removeChild(link); // Clean up
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
        });
    },
    editProduct(id) {
      // console.log('request edit product', id)
      this.$router.push({
        path: "/device/prodedit",
        query: {
          id: id
        }
      })
    },
    getProductTypes(project) {
      if (project) {
        this.$request.get(`/api/device/products/project/${project}`).then(res => {
          // console.log(res.data)
          this.currentItems = res.data.products
          this.detail = true
        })
      } else {
        this.$request.get('/api/device/products').then(res => {
          // console.log(res.data)
          this.currentItems = res.data.products
          this.detail = false
        })
      }
    },
    getProducts(name) {
      this.currentProduct=name
      this.$showBusy()
      this.$request.get(`/api/device/products/${name}`).then(res=>{
        // console.log(res.data)
        this.currentItems = res.data.products
        this.projectsUseProduct= res.data.projectsUseProduct
        this.detail=true
        this.$closeBusy()
      })
    },
    renameProjectForProduct() {
      // console.log('rename project for: ', this.currentProduct)
      this.$swal.fire({
        title: "Lưu thông tin sản phẩm?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/device/products/renameprjbasetime`, {
            project: this.targetProject,
            product: this.currentProduct,
            start: this.startDate,
            stop: this.stopDate,
          }).
          then(res => {
            if(res.data.status === 'success') {
              this.startDate=''
              this.stopDate=''
              this.targetProject=''
              this.currentItems = res.data.products
              this.$swal.fire({
                icon: "success",
                title: "Cập nhật thông tin sản phẩm",
                html: "Lưu thông tin sản phẩm thành công"
              });
            }
          })
        }
      });
    },
    rowClicked(item, index) {
      // console.log('row clicked get item: ', item, ' detail: ', this.detail)
      if (this.detail && this.isSuper) {
        // console.log('get detail for item: ', item)
        this.$router.push({
          path: '/device/licedit',
          query: {
            id: item.id
          }
        })
      } else {
        this.getProducts(item.product)
      }
    },
    goBack() {
      this.getProductTypes()
    },
    onActionClick(item) {
      if(!this.isSuper) {
        return
      }
      // console.log('clicked item:', item)
      this.$router.push({
        path: '/device/prodedit',
        query: {
          id: item.id,
        }
      })
    },
    requestProductDate(){
      this.$request.get(`/api/device/products/${this.currentProduct}?start=${this.startDate}&&stop=${this.stopDate}`).then(res=>{
        // console.log(res.data)
        this.currentItems = res.data.products
      })
    },
  },
};
</script>

<style scoped>
.clickable-text {
  cursor: pointer;
  text-decoration: none; /* Default: No underline */
  vertical-align: center;
  font-weight: bold;
}

.clickable-text:hover {
  text-decoration: underline; /* Underline only on hover */
}
</style>
